import styled, { css } from 'styled-components'

export const Container = styled.div``

export const Title = styled.h4`
  ${({ theme }) => theme.textStyles.WebTitleH2};
  color: ${({ theme }) => theme.colors.pureBlack};
  margin-bottom: 20px;
`

export const Items = styled.div`
  width: 100%;
  overflow: auto;
  aspect-ratio: 1 / 1;
`

export const Item = styled.button<{ $selected?: boolean }>`
  width: 100%;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.colors.pureBlack};
  ${({ theme }) => theme.textStyles.body};
  color: ${({ theme }) => theme.colors.greyDark};
  background-color: transparent;
  padding: 12px;
  text-align: left;
  cursor: pointer;

  ${({ $selected }) =>
    $selected &&
    css`
      background-color: black;
      color: white;
    `};

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.3;
      cursor: not-allowed;
    `};
`
